export function isValidCarInfoValue(value) {
  return value && value !== 'null'
}

export function hasCarInfo(carInfo) {
  if (!carInfo || typeof carInfo !== 'object') return false
  return isValidCarInfoValue(carInfo.color)
    || isValidCarInfoValue(carInfo.model)
    || isValidCarInfoValue(carInfo.number)
}

export function formatCarInfo(carInfo, { html = false, boldClass = 'font-weight-bold' } = {}) {
  if (!hasCarInfo(carInfo)) return null

  const colorVal = isValidCarInfoValue(carInfo.color) ? carInfo.color : null
  const modelVal = isValidCarInfoValue(carInfo.model) ? carInfo.model : null
  const numberVal = isValidCarInfoValue(carInfo.number) ? carInfo.number : null

  if (html) {
    const parts = []
    if (colorVal) parts.push(`<span class="${boldClass}">${colorVal}</span>`)
    if (modelVal) parts.push(modelVal)
    if (numberVal) parts.push(numberVal)
    return parts.join(', ') || null
  }

  return [colorVal, modelVal, numberVal].filter(Boolean).join(', ') || null
}
